module.exports = __webpack_public_path__ + "img/yeschoose.11376940.svg";